module.exports = __webpack_public_path__ + "img/helpdesk.c2c566b2.jpg";